/* Shared site-nav: mobile menu toggle.
   The account avatar and menu live in account-menu.js, which reads
   identity.js — both are loaded before this file. */
(function () {

  /* ---- Mobile burger ---- */
  function wireBurger() {
    document.querySelectorAll('.snav-burger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('.snav');
        if (bar) bar.classList.toggle('open');
      });
    });
  }

  function wire() {
    wireBurger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

})();
